import {
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
  AbsoluteCenter,
  Tooltip,
} from '@chakra-ui/react';
import moment from 'moment';
import { Spinner } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { AddIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';

import { usePermissions } from 'contexts/PermissionContext';
// Custom components
import Card from 'components/card/Card';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';
import BankAccountApi from 'api/bankaccounts';

export default function TableData(props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const [list, setList] = useState([]);

  const [loading, setLoading] = useState(false);

  const { getPermissionsForModule } = usePermissions();
  const [customerBankAccountPermissions, setCustomerBankPermissions] =
    useState(null);

  const userId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }

  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await BankAccountApi.List({
        userId,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setList(response?.data);
      } else {
        setList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    const customerBankAccountPermissions = getPermissionsForModule([
      Modules.CustomerBank,
    ]);
    setCustomerBankPermissions(customerBankAccountPermissions);

    if (!hasFetched) {
      fetchList();
      setHasFetched(true);
    }
  }, []);

  console.log('permission', customerBankAccountPermissions);

  // If user doesn't have read permissions, show a message and exit early
  if (!customerBankAccountPermissions?.read) {
    return <NoPermissionsMessage module={Modules.CustomerBank} />;
  }

  return (
    <Flex height='100%' direction='column'>
      <Flex px='25px' justify='space-between' mb='20px' align='center'>
        <Center>
          <Text fontWeight='bold' fontSize='lg' mb={4}>
            Associated Bank Accounts
          </Text>
        </Center>

        {console.log('create', customerBankAccountPermissions.create)}
        <Flex gap={4}>
          <Tooltip
            label={
              !customerBankAccountPermissions.create
                ? 'You do not have permission to add new Accounts'
                : undefined
            }
            placement='top'
            shouldWrapChildren
          >
            <AddModal
              Icon={<AddIcon />}
              head={'Add New Bank Account'}
              func={fetchList}
              userId={userId}
              disabled={
                !customerBankAccountPermissions.create ||
                !customerBankAccountPermissions.read
              }
            />
          </Tooltip>
        </Flex>
      </Flex>
      <Card
        direction='column'
        w='100%'
        px='0px'
        maxH='334px'
        bgColor='gray.200'
        // mt={{ base: '180px', md: '120px' }}
      >
        <Flex overflow='scroll'>
          <Table variant='simple' color='gray.500' mb='24px'>
            <Thead position='sticky' top={0} bg='gray.200' zIndex={1}>
              <Tr>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Holder Name
                  </Flex>
                </Th>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Account Number
                  </Flex>
                </Th>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Bank
                  </Flex>
                </Th>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Branch
                  </Flex>
                </Th>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Created on
                  </Flex>
                </Th>
                <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Actions
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {loading ? (
                <Box height='300px'>
                  <AbsoluteCenter
                  // bgColor='red'
                  >
                    <Spinner size='xl' />
                  </AbsoluteCenter>
                </Box>
              ) : (
                list?.map((obj, index) => {
                  return (
                    <Tr key={obj.id}>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            {obj.holder_name}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            {obj.account_number}
                          </Text>
                          {obj.default && <Text color='green'>(Default)</Text>}
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            {obj.bank_name}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            {obj.bank_branch}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            {moment(obj.created_at).format('DD MMM YY, HH:mm')}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <EditModal
                            Icon={<InfoOutlineIcon />}
                            head={'Account Details'}
                            accountDetails={obj}
                          />
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })
              )}
            </Tbody>
          </Table>
        </Flex>
      </Card>
    </Flex>
  );
}
